import produce from 'immer'
import * as types from 'Redux/Types/PreferenceTypes'

const defaultAuditLogColumns = [
  { id: 'actorDatetime', label: 'Date/Time', active: true },
  { id: 'merchantName', label: 'Merchant', active: true },
  { id: 'total', label: 'Total Amount', financial: true, align: 'right', active: true },
  { id: 'actor', label: 'User', active: true },
  { id: 'change', label: 'Activity', active: true },
  { id: 'oldValue', label: 'Old Value', active: true },
  { id: 'newValue', label: 'New Value', active: true },
]

const defaultConfidenceScoreColumns = [
  { id: 'transactionDate', label: 'Transaction Date', active: true },
  { id: 'riskScore', label: 'Risk Score', active: true },
  { id: 'merchant', label: 'Merchant', active: true },
  { id: 'exceptions', label: 'Exceptions', active: false },
  { id: 'exceptionCount', label: 'Exception Count', active: false },
  { id: 'documentType', label: 'Document Type', active: true },
  { id: 'createdDate', label: 'Upload Date', active: false },
  { id: 'dueDate', label: 'Due Date', active: false },
  { id: 'expenseCategory', label: 'Category', active: false },
  { id: 'glCode', label: 'GL Code', active: false },
  {
    id: 'subtotal',
    label: 'Subtotal',
    financial: true,
    align: 'right',
    noSort: true,
  },
  { id: 'tax', label: 'Tax', financial: true, align: 'right', noSort: true },
  {
    id: 'total',
    label: 'Grand Total',
    financial: true,
    align: 'right',
    active: true,
  },
  {
    id: 'paymentStatus',
    label: 'Status',
    align: 'center',
    headStyle: { tableSortLabel: { marginRight: -24 } },
    active: false,
  },
]

const defaultExpenseColumns = [
  { id: 'merchant', label: 'Vendor', active: true, isReportHeader: true },
  { id: 'fileName', label: 'Name', active: false, isReportHeader: false },
  { id: 'createdDate', label: 'Upload Date', active: true, isReportHeader: false },
  { id: 'documentType', label: 'Type', active: true, isReportHeader: false },
  { id: 'documentNumber', label: 'Document Number', active: true, isReportHeader: false },
  { id: 'purchaseOrderNumber', label: 'PO-Number', active: true, isReportHeader: false },
  { id: 'source', label: 'Source', active: true, isReportHeader: false },
  {
    id: 'total',
    label: 'Amount',
    financial: true,
    align: 'right',
    active: true,
    isReportHeader: false,
  },
  //{ id: 'riskScore', label: 'Risk', active: true, isReportHeader: false },
  { id: 'workflowStatus', label: 'Status', active: true, isReportHeader: false },
  { id: 'exceptions', label: 'Exceptions Details', active: false, isReportHeader: false },
  { id: 'exceptionCount', label: 'Exceptions', active: false, isReportHeader: false },
  { id: 'transactionDate', label: 'Transaction Date', active: false, isReportHeader: false },
  { id: 'dueDate', label: 'Due Date', active: false, isReportHeader: false },
  { id: 'expenseCategory', label: 'Category', active: false, isReportHeader: false },
  { id: 'glCode', label: 'GL Code', active: false, isReportHeader: false },
  {
    id: 'subtotal',
    label: 'Subtotal',
    financial: true,
    align: 'right',
    noSort: true,
    active: false,
    isReportHeader: false,
  },
  {
    id: 'tax',
    label: 'Tax',
    financial: true,
    align: 'right',
    noSort: true,
    active: false,
    isReportHeader: false,
  },
  {
    id: 'paymentTermsDiscount',
    label: 'Discount',
    financial: true,
    align: 'right',
    active: false,
    isReportHeader: false,
  },
  {
    id: 'paymentStatus',
    label: 'Payment',
    align: 'center',
    headStyle: { tableSortLabel: { marginRight: -24 } },
    active: false,
    isReportHeader: false,
  },
  { id: 'isBankMatched', label: 'Bank Matched', active: true, isReportHeader: false },
  {
    id: 'actions',
    label: 'Actions',
    align: 'center',
    noSort: true,
    active: true,
    isReportHeader: false,
  },
]

const defaultIntegrationExportColumns = [
  { id: 'exportStatus', label: 'Export Status', active: true, noSort: true, isReportHeader: false },
  { id: 'merchant', label: 'Vendor', active: true, isReportHeader: true },
  { id: 'fileName', label: 'Name', active: false, isReportHeader: false },
  { id: 'createdDate', label: 'Upload Date', active: true, isReportHeader: false },
  { id: 'documentType', label: 'Type', active: true, isReportHeader: false },
  { id: 'documentNumber', label: 'Document Number', active: true, isReportHeader: false },
  { id: 'purchaseOrderNumber', label: 'PO-Number', active: true, isReportHeader: false },
  { id: 'source', label: 'Source', active: true, isReportHeader: false },
  {
    id: 'total',
    label: 'Amount',
    financial: true,
    align: 'right',
    active: true,
    isReportHeader: false,
  },
  //{ id: 'riskScore', label: 'Risk', active: true, isReportHeader: false },
  { id: 'workflowStatus', label: 'Status', active: true, isReportHeader: false },
  { id: 'exceptions', label: 'Exceptions Details', active: false, isReportHeader: false },
  { id: 'exceptionCount', label: 'Exceptions', active: false, isReportHeader: false },
  { id: 'transactionDate', label: 'Transaction Date', active: false, isReportHeader: false },
  { id: 'dueDate', label: 'Due Date', active: false, isReportHeader: false },
  { id: 'expenseCategory', label: 'Category', active: false, isReportHeader: false },
  { id: 'glCode', label: 'GL Code', active: false, isReportHeader: false },
  {
    id: 'subtotal',
    label: 'Subtotal',
    financial: true,
    align: 'right',
    noSort: true,
    active: false,
    isReportHeader: false,
  },
  {
    id: 'tax',
    label: 'Tax',
    financial: true,
    align: 'right',
    noSort: true,
    active: false,
    isReportHeader: false,
  },
  {
    id: 'paymentTermsDiscount',
    label: 'Discount',
    financial: true,
    align: 'right',
    active: false,
    isReportHeader: false,
  },
  {
    id: 'paymentStatus',
    label: 'Payment',
    align: 'center',
    headStyle: { tableSortLabel: { marginRight: -24 } },
    active: false,
    isReportHeader: false,
  },
  { id: 'isBankMatched', label: 'Bank Matched', active: true, isReportHeader: false },
  {
    id: 'actions',
    label: 'Actions',
    align: 'center',
    noSort: true,
    active: true,
    isReportHeader: false,
  },
]

const defaultExceptionColumns = [
  { id: 'merchant', label: 'Vendor', active: true },
  { id: 'fileName', label: 'Name', active: false },
  { id: 'createdDate', label: 'Upload Date', active: true },
  { id: 'documentType', label: 'Type', active: true },
  { id: 'documentNumber', label: 'Document Number', active: true },
  { id: 'purchaseOrderNumber', label: 'PO-Number', active: true },
  { id: 'source', label: 'Source', active: false },
  { id: 'total', label: 'Amount', financial: true, align: 'right', active: true },
  { id: 'riskScore', label: 'Risk', active: false },
  { id: 'exceptions', label: 'Exceptions Details', active: true },
  { id: 'exceptionCount', label: 'Exceptions', active: true },
  { id: 'workflowStatus', label: 'Status', active: true },
  { id: 'transactionDate', label: 'Transaction Date', active: false },
  { id: 'dueDate', label: 'Due Date', active: false },
  { id: 'expenseCategory', label: 'Category', active: false },
  { id: 'glCode', label: 'GL Code', active: false },
  {
    id: 'subtotal',
    label: 'Subtotal',
    financial: true,
    align: 'right',
    noSort: true,
    active: false,
  },
  { id: 'tax', label: 'Tax', financial: true, align: 'right', noSort: true, active: false },
  { id: 'paymentTermsDiscount', label: 'Discount', financial: true, align: 'right', active: false },
  {
    id: 'paymentStatus',
    label: 'Payment',
    align: 'center',
    headStyle: { tableSortLabel: { marginRight: -24 } },
    active: false,
  },
  { id: 'isBankMatched', label: 'Bank Matched', active: true, isReportHeader: false },
  { id: 'actions', label: 'Actions', align: 'center', noSort: true, active: false },
]

const defaultVendorColumns = [
  { id: 'name', label: 'Vendor Name', active: true },
  { id: 'address', label: 'Vendor Address', active: true },
  { id: 'alias', label: 'Vendor Alias', active: true },
  { id: 'expenseCategory', label: 'Expense Category', active: true },
  { id: 'glCode', label: 'GL Code', active: true },
  { id: 'status', label: 'Status', active: true },
  { id: 'totalDocs', label: 'Total Docs', align: 'center', active: true },
]

const defaultExportColumns = [
  { id: 'fileName', label: 'Name', active: true, isReportHeader: false, visible: false },
  { id: 'createdDate', label: 'Upload Date', active: true, isReportHeader: false, visible: true },
  { id: 'merchant', label: 'Vendor', active: true, isReportHeader: true, visible: true },
  { id: 'documentType', label: 'Type', active: true, isReportHeader: false, visible: true },
  {
    id: 'documentNumber',
    label: 'Document Number',
    active: true,
    isReportHeader: false,
    visible: true,
  },
  {
    id: 'purchaseOrderNumber',
    label: 'PO-Number',
    active: true,
    isReportHeader: false,
    visible: true,
  },
  { id: 'source', label: 'Source', active: true, isReportHeader: false, visible: true },
  {
    id: 'total',
    label: 'Amount',
    financial: true,
    align: 'right',
    active: true,
    isReportHeader: false,
    visible: true,
  },
  //{ id: 'riskScore', label: 'Risk', active: true, isReportHeader: false, visible: true },
  { id: 'workflowStatus', label: 'Status', active: true, isReportHeader: false, visible: true },
  {
    id: 'exceptions',
    label: 'Exceptions Details',
    active: false,
    isReportHeader: false,
    visible: false,
  },
  {
    id: 'exceptionCount',
    label: 'Exceptions',
    active: false,
    isReportHeader: false,
    visible: true,
  },
  {
    id: 'transactionDate',
    label: 'Transaction Date',
    active: false,
    isReportHeader: false,
    visible: true,
  },
  { id: 'dueDate', label: 'Due Date', active: false, isReportHeader: false, visible: true },
  { id: 'expenseCategory', label: 'Category', active: false, isReportHeader: false, visible: true },
  { id: 'glCode', label: 'GL Code', active: false, isReportHeader: false, visible: true },
  {
    id: 'subtotal',
    label: 'Subtotal',
    financial: true,
    align: 'right',
    noSort: true,
    active: false,
    isReportHeader: false,
    visible: true,
  },
  {
    id: 'tax',
    label: 'Tax',
    financial: true,
    align: 'right',
    noSort: true,
    active: false,
    isReportHeader: false,
    visible: true,
  },
  {
    id: 'paymentTermsDiscount',
    label: 'Discount',
    financial: true,
    align: 'right',
    active: false,
    isReportHeader: false,
    visible: true,
  },
  {
    id: 'paymentStatus',
    label: 'Payment',
    align: 'center',
    headStyle: { tableSortLabel: { marginRight: -24 } },
    active: false,
    isReportHeader: false,
    visible: true,
  },
  {
    id: 'actions',
    label: 'Actions',
    align: 'center',
    noSort: true,
    active: true,
    isReportHeader: false,
    visible: false,
  },
]

const defaultPaymentsColumns = [
  { id: 'checkbox', label: '', active: true, noSort: true, isReportHeader: false, visible: false },
  {
    id: 'paymentStatus',
    label: 'Payment',
    align: 'center',
    headStyle: { tableSortLabel: { marginRight: -24 } },
    active: true,
    isReportHeader: false,
    visible: true,
  },
  { id: 'merchant', label: 'Vendor', active: true, isReportHeader: true, visible: true },
  {
    id: 'documentNumber',
    label: 'Document Number',
    active: true,
    isReportHeader: false,
    visible: true,
  },
  {
    id: 'purchaseOrderNumber',
    label: 'PO-Number',
    active: false,
    isReportHeader: false,
    visible: true,
  },
  { id: 'createdDate', label: 'Upload Date', active: true, isReportHeader: false, visible: true },
  {
    id: 'transactionDate',
    label: 'Transaction Date',
    active: false,
    isReportHeader: false,
    visible: true,
  },
  { id: 'dueDate', label: 'Due Date', active: true, isReportHeader: false, visible: true },
  {
    id: 'subtotal',
    label: 'Subtotal',
    financial: true,
    align: 'right',
    noSort: true,
    active: false,
    isReportHeader: false,
    visible: true,
  },
  {
    id: 'tax',
    label: 'Tax',
    financial: true,
    align: 'right',
    noSort: true,
    active: false,
    isReportHeader: false,
    visible: true,
  },
  {
    id: 'total',
    label: 'Amount',
    financial: true,
    align: 'right',
    active: true,
    isReportHeader: false,
    visible: true,
  },
  //{ id: 'riskScore', label: 'Risk', active: true, isReportHeader: false, visible: true },
  { id: 'expenseCategory', label: 'Category', active: false, isReportHeader: false, visible: true },
  { id: 'glCode', label: 'GL Code', active: false, isReportHeader: false, visible: true },
  {
    id: 'actions',
    label: 'Actions',
    align: 'center',
    noSort: true,
    active: false,
    isReportHeader: false,
    visible: false,
  },
]

const defaultTransactionColumns = [
  { id: 'transactionStatus', label: 'Transaction Status', active: true, noSort: true },
  { id: 'id', label: 'ID', active: false, noSort: true },
  { id: 'izGuid', label: 'IZ: GUID', active: false, noSort: true },
  { id: 'status', label: 'Status', active: true },
  { id: 'izUploadDate', label: 'IZ: Upload Date', active: true, noSort: true },
  { id: 'izTransactionDate', label: 'IZ: Document Date', active: true },
  { id: 'izMerchantName', label: 'IZ: Vendor Name', active: true, noSort: true },
  { id: 'izAmount', label: 'IZ: Grand Total', financial: true, active: true, noSort: true },
  { id: 'paymentType', label: 'IZ: Payment Method', active: false, noSort: true },
  //{ id: 'izTransactionId', label: 'IZ Bank Tranx ID', active: true, noSort: true },
  { id: 'bankName', label: 'Bank: Institution', active: true, noSort: true },
  { id: 'bankAccountName', label: 'Bank: Account Name', active: true, noSort: true },
  //{ id: 'bankTransactionId', label: 'Bank Tranx Id', active: true, noSort: true },
  { id: 'bankPostingDate', label: 'Bank: Posting Date', active: true, noSort: true },
  { id: 'bankMerchantName', label: 'Bank: Vendor Name', active: true, noSort: true },
  { id: 'bankAmount', label: 'Bank: Grand Total', financial: true, active: true, noSort: true },
  { id: 'bankPaymentType', label: 'Bank: Payment Method', active: false, noSort: true },
  { id: 'subacctId', label: 'Bank: Subacct ID', active: false, noSort: true },
]

const defaultArchiveTransactionColumns = [
  { id: 'transactionStatus', label: 'Archive Status', active: true, noSort: true },
  { id: 'id', label: 'ID', active: false, noSort: true },
  { id: 'izGuid', label: 'IZ: GUID', active: false, noSort: true },
  { id: 'status', label: 'Status', active: true },
  { id: 'izUploadDate', label: 'IZ: Upload Date', active: true, noSort: true },
  { id: 'izTransactionDate', label: 'IZ: Document Date', active: true },
  { id: 'izMerchantName', label: 'IZ: Vendor Name', active: true, noSort: true },
  { id: 'izAmount', label: 'IZ: Grand Total', financial: true, active: true, noSort: true },
  { id: 'paymentType', label: 'IZ: Payment Method', active: false, noSort: true },
  //{ id: 'izTransactionId', label: 'IZ Bank Tranx ID', active: true, noSort: true },
  { id: 'bankName', label: 'Bank: Institution', active: true, noSort: true },
  { id: 'bankAccountName', label: 'Bank: Account Name', active: true, noSort: true },
  //{ id: 'bankTransactionId', label: 'Bank Tranx Id', active: true, noSort: true },
  { id: 'bankPostingDate', label: 'Bank: Posting Date', active: true, noSort: true },
  { id: 'bankMerchantName', label: 'Bank: Vendor Name', active: true, noSort: true },
  { id: 'bankAmount', label: 'Bank: Grand Total', financial: true, active: true, noSort: true },
  { id: 'bankPaymentType', label: 'Bank: Payment Method', active: false, noSort: true },
  { id: 'subacctId', label: 'Bank: Subacct ID', active: false, noSort: true },
]

const initialState = {
  auditLogColumns: defaultAuditLogColumns,
  confidenceScoreColumns: defaultConfidenceScoreColumns,
  defaultAuditLogColumns,
  defaultConfidenceScoreColumns,
  defaultExpenseColumns,
  defaultVendorColumns,
  defaultExceptionColumns,
  expenseColumns: defaultExpenseColumns,
  defaultIntegrationExportColumns: defaultIntegrationExportColumns,
  exportColumns: defaultExportColumns,
  vendorColumns: defaultVendorColumns,
  paymentsColumns: defaultPaymentsColumns,
  defaultTransactionColumns: defaultTransactionColumns,
  defaultArchiveTransactionColumns: defaultArchiveTransactionColumns,
}

const resetPreference = (draft, { key, defaultKey }) => {
  draft[key] = initialState[defaultKey]
}

const setPreference = (draft, { key, value }) => {
  draft[key] = value
}

const preferenceReducer = (state = initialState, action) => {
  return produce(state, (draft) => {
    const { type, payload } = action

    switch (type) {
      case types.RESET_PREFERENCE:
        return resetPreference(draft, payload)

      case types.SET_PREFERENCE:
        return setPreference(draft, payload)

      // no default
    }
  })
}

export default preferenceReducer
